export class PaymentProviderConfig {
  id: string;
  provider_id: string;
  bank_account_number: string;
  account_name: string;
  status: string;

  constructor(data: any) {
    this.id = data.id;
    this.provider_id = data.provider_id;
    this.bank_account_number = data.bank_account_number;
    this.account_name = data.account_name;
    this.status = data.status || 'INACTIVE';
  }

  isActive(): boolean {
    return this.status === 'ACTIVE';
  }

  static build(data: any): PaymentProviderConfig | undefined {
    if (!data) {
      return undefined;
    }
    return new PaymentProviderConfig(data);
  }
}
